<template>
  <div style="display: flex">
    <div style="flex-shrink: 0">
      <img
        :src="componente.value.imageUrl"
        alt="Image"
        @load="$emit('loaded')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewShowImage',
  props: {
    componente: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped></style>
